import { usePayseraEmailLoginMutation } from 'api/core/generated';
import { AppApiVersions, AppSearchParams } from 'app-constants';
import { useSearchParams } from 'react-router-dom';

export const usePayseraEmailLogin = () => {
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get(
    AppSearchParams.payseraLoginPaymentStatus,
  );

  const [emailLoginByPaysera, { data, loading, error }] =
    usePayseraEmailLoginMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const payseraEmailLogin = (email: string) =>
    emailLoginByPaysera({ variables: { email, session_id } });

  return {
    payseraEmailLogin,
    payseraEmailLoginSuccess: Boolean(data?.success),
    payseraEmailLoginProcessing: loading,
    payseraEmailLoginError: error,
  };
};
